module.exports = __webpack_public_path__ + "static/img/cqxc1.7a721ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/cqxc1.png
// module id = johy
// module chunks = 0